import React, {Component, Fragment} from 'react';
import {Navbar} from "react-bootstrap";
import navlogo from '../Assets/Images/navlogo.svg';
class MenuBar extends Component {
    render() {
        return (
            <Fragment>
                <Navbar className="sticky-top" bg="light">
                    <Navbar.Brand ><img alt="nav logo" className="nav-logo" src={navlogo}/></Navbar.Brand>
                </Navbar>
            </Fragment>
        );
    }
}

export default MenuBar;